(function () {
  function getCartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  async function addVariantToCart(variantId) {
    const cartComponent = getCartComponent();
    const sections = cartComponent
      ? cartComponent.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-icon-bubble'];

    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname,
      }),
    });
    const data = await resp.json();
    if (!resp.ok) return { ok: false, error: data.description || 'Sin stock' };

    if (cartComponent && data.sections) {
      cartComponent.classList.remove('is-empty');
      cartComponent.renderContents(data);
    }
    if (typeof publish === 'function') {
      publish('cart-update', { source: 'card-variants-hover', cartData: data });
    }
    return { ok: true };
  }

  function setStatus(panel, text, isError) {
    var s = panel.querySelector('.card__hover-status');
    if (!s) return;
    s.textContent = text;
    s.className = 'card__hover-status card__hover-status--visible' + (isError ? ' card__hover-status--error' : '');
  }

  function clearStatus(panel) {
    var s = panel.querySelector('.card__hover-status');
    if (!s) return;
    s.textContent = '';
    s.className = 'card__hover-status';
  }

  function getSelections(panel) {
    var groups = panel.querySelectorAll('.card__hover-option-group');
    var sel = {};
    groups.forEach(function (g) {
      var idx = parseInt(g.dataset.optionIndex, 10);
      var active = g.querySelector('.card__size-pill.is-selected');
      if (active) sel[idx] = active.dataset.optionValue;
    });
    return sel;
  }

  function findVariant(panel, selections, optCount) {
    var dataEl = panel.querySelector('.card__hover-variants-data');
    if (!dataEl) return null;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    return variants.find(function (v) {
      for (var i = 0; i < optCount; i++) {
        if (v.options[i] !== selections[i]) return false;
      }
      return true;
    }) || null;
  }

  document.addEventListener('click', async function (e) {
    var pill = e.target.closest('.card__size-pill');
    if (!pill || pill.disabled) return;

    var panel = pill.closest('.card__hover-variants');
    if (!panel || panel.dataset.adding) return;

    var group = pill.closest('.card__hover-option-group');
    if (group) {
      group.querySelectorAll('.card__size-pill.is-selected').forEach(function (p) {
        p.classList.remove('is-selected');
      });
    }
    pill.classList.add('is-selected');

    var optCount = parseInt(panel.dataset.optionsCount, 10);
    var selections = getSelections(panel);

    if (Object.keys(selections).length < optCount) {
      clearStatus(panel);
      return;
    }

    var variant = findVariant(panel, selections, optCount);
    if (!variant) { setStatus(panel, 'No disponible', true); return; }
    if (!variant.available) { setStatus(panel, 'Sin stock', true); return; }

    panel.dataset.adding = '1';
    setStatus(panel, '...');

    try {
      var result = await addVariantToCart(variant.id);
      if (result.ok) {
        panel.querySelectorAll('.card__size-pill.is-selected').forEach(function (p) {
          p.classList.add('is-added');
        });
        setStatus(panel, '✓ Agregado');
        setTimeout(function () {
          panel.querySelectorAll('.card__size-pill.is-selected, .card__size-pill.is-added').forEach(function (p) {
            p.classList.remove('is-selected', 'is-added');
          });
          clearStatus(panel);
          delete panel.dataset.adding;
        }, 2000);
      } else {
        setStatus(panel, result.error, true);
        setTimeout(function () { clearStatus(panel); delete panel.dataset.adding; }, 2500);
      }
    } catch (_) {
      clearStatus(panel);
      delete panel.dataset.adding;
    }
  });
})();
